import {
  required,
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  FormDataConsumer,
  TextInput,
  useNotify,
} from "react-admin";
import * as S from './index.styles';
import CustomFileInput from "../../../components/CustomFileInput/CustomFileInput";
import { useRef, useEffect } from "react";
import { getPanelValidationErrorMessage } from "../utils";
import { FileValidationCard } from "../../../components";
import { Button } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import PanelFormToolbar from '../PanelFormToolbar';
import usePanelCsvValidation from '../usePanelCsvValidation';

const validateRequired = required();

const FileValidator = ({ file, onValidate }) => {
  const lastFileRef = useRef(null);

  useEffect(() => {
    if (file && file.rawFile && lastFileRef.current !== file.rawFile) {
      lastFileRef.current = file.rawFile;
      onValidate(file);
    } else if (!file) {
      lastFileRef.current = null;
      onValidate(null);
    }
  }, [file, onValidate]);

  return null;
};

const PanelCreate = (props) => {
  const notify = useNotify();
  const {
    csvValidation,
    isValidating,
    errorCsv,
    errorFileInfo,
    successFileInfo,
    hasSuccessfulCsvValidation,
    hasCsvErrors,
    validateCsv,
    handleDownloadErrorCsv,
  } = usePanelCsvValidation({ notify });

  return (
    <Create title="Criar Painel" {...props}>
      <SimpleForm
        redirect="list"
        toolbar={
          <PanelFormToolbar
            hasSuccessfulCsvValidation={hasSuccessfulCsvValidation}
            hasCsvErrors={hasCsvErrors}
            isValidating={isValidating}
          />
        }
      >
        <FormDataConsumer>
          {({ formData }) => {
            return (
              <>
                <h4>Crie lista de Painel segmentado</h4>
                <S.View>
                  <TextInput
                    label="Digite o nome da lista"
                    source="name"
                    validate={validateRequired}
                    className="max-width"
                  />

                  <div className="max-width">
                    <ReferenceInput
                      sort={{ field: "name", order: "ASC" }}
                      perPage={999}
                      resource="lab"
                      source="labId"
                      reference="labs"
                      validate={validateRequired}
                    >
                      <SelectInput label="Selecione o laboratório" optionText="name" optionValue="id" className="max-width" />
                    </ReferenceInput>
                  </div>

                  {formData.labId && (
                    <div className="max-width">
                      <ReferenceInput
                        perPage={999}
                        source="projectId"
                        reference="projects"
                        filter={{ project: { labId: formData.labId } }}
                        sort={{ field: "id", order: "DESC" }}
                      >
                        <SelectInput
                          label="Selecione o projeto"
                          optionText="name"
                          optionValue="id"
                          className="max-width"
                          validate={validateRequired}
                        />
                      </ReferenceInput>
                    </div>
                  )}

                  {formData.projectId && (
                    <SelectInput
                      label="Objetivo da lista"
                      source="statusObjective"
                      choices={[
                        { id: 0, name: 'Entrega' },
                      ]}
                      validate={validateRequired}
                      className="max-width"
                    />
                  )}

                  <CustomFileInput
                    source="panels"
                    accept=".csv,text/csv"
                    validate={validateRequired}
                    uploadText="Arraste o arquivo aqui ou clique para selecionar"
                    formatText="Formato aceito: .CSV"
                    className="full-width"
                    isValid={hasSuccessfulCsvValidation && !isValidating}
                    options={{
                      onDropRejected: () =>
                        notify("Arquivo inválido. Apenas arquivos .CSV são aceitos.", { type: "error" })
                    }}
                  >
                  </CustomFileInput>

                  <FileValidator
                    file={formData.panels}
                    onValidate={validateCsv}
                  />
                </S.View>
              </>
            );
          }}
        </FormDataConsumer>

        {csvValidation && (csvValidation.valid || csvValidation.isValid) && !csvValidation.error && successFileInfo && !isValidating && (
          <S.FullWidthFeedback>
          <FileValidationCard
            variant="success"
            file={successFileInfo}
          />
          </S.FullWidthFeedback>
        )}
        {csvValidation && !(csvValidation.valid || csvValidation.isValid) && !csvValidation.error && errorCsv && !isValidating && (
          <S.FullWidthFeedback>
          <FileValidationCard
            variant="error"
            file={errorFileInfo}
            message={getPanelValidationErrorMessage(csvValidation)}
            action={
              <Button
                onClick={() => handleDownloadErrorCsv(errorFileInfo)}
                variant="outlined"
                size="small"
                startIcon={<GetAppIcon />}
                style={{
                  color: "#C62828",
                  borderColor: "#C62828",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {isValidating ? "Processando..." : "Baixar planilha de erros"}
              </Button>
            }
          />
          </S.FullWidthFeedback>
        )}

        <a
          style={{ marginTop: 20, fontSize: 13 }}
          id="download-example-file"
          href="https://drive.google.com/file/d/1CyV4i5zNthV3_DXfIPqJxpltt63QMA7w/view" target="_blank"
          rel="noopener noreferrer">
          Baixe aqui a planilha modelo de lista de painel
        </a>
      </SimpleForm>
    </Create>
  );
};

export default PanelCreate;
